import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router";
import AuthService from "../../services/authService";

const menuItems = [
  {
    text: "Member Success",
    icon: <i className="fas fa-heartbeat" />,
    path: "/dashboard",
  },
  { text: "Users", icon: <i className="fas fa-users" />, path: "/users" },
  {
    text: "Exercises",
    icon: <i className="fas fa-chart-line" />,
    path: "/exercises",
  },
  {
    text: "Equipments",
    icon: <i className="fas fa-dumbbell" />,
    path: "/equipments",
  },
  {
    text: "Notifications",
    icon: <i className="fas fa-bell" />,
    path: "/notifications",
  },
  {
    text: "Programs & Categories",
    icon: <i className="fas fa-list" />,
    path: "/programs",
  },
  {
    text: "Trainers",
    icon: <i className="fas fa-list" />,
    path: "/trainers",
  },
  {
    text: "Trainer Programs",
    icon: <i className="fas fa-list" />,
    path: "/week-program",
  },
  {
    text: "Trainer Tutorials",
    icon: <i className="fas fa-list" />,
    path: "/htp",
  },
  {
    text: "New Programs",
    icon: <i className="fas fa-calendar-week" />,
    path: "/trainer-programs",
  },
  {
    text: "Exercise Swaps",
    icon: <i className="fas fa-random" />,
    path: "/exercise-swaps",
  },
  {
    text: "Profile Photos",
    icon: <i className="fas fa-image" />,
    path: "/profile-photos",
  },
];

const Sidebar: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [isLoggingOut, setIsLoggingOut] = useState(false);

  const handleLogout = async () => {
    setIsLoggingOut(true);
    try {
      AuthService.logout();

      navigate("/login");
    } catch (error) {
      console.error("Logout failed", error);
    } finally {
      setIsLoggingOut(false);
    }
  };

  return (
    <div className="h-screen w-20 min-w-60 bg-secondary text-white flex flex-col justify-between">
      <div>
        <div className="flex justify-center items-center p-4 bg-secondary">
          <h3 className="text-2xl font-bold text-white">12REPS</h3>
        </div>
        <ul className="flex flex-col">
          {menuItems.map((item, index) => (
            <li
              key={index}
              onClick={() => navigate(item.path)}
              className={`flex items-center px-6 py-3 cursor-pointer transition-all duration-300 relative ${
                location.pathname === item.path
                  ? "bg-white text-primary"
                  : "bg-secondary text-gray-400"
              } hover:bg-white hover:text-primary`}
            >
              {location.pathname === item.path && (
                <div className="absolute right-0 top-0 bottom-0 w-1 bg-primary"></div>
              )}
              <span
                className={`mr-3 ${
                  location.pathname === item.path
                    ? "text-primary"
                    : "text-gray-400"
                }`}
              >
                {item.icon}
              </span>
              <span>{item.text}</span>
            </li>
          ))}
        </ul>
      </div>

      <div className="p-4 border-t border-gray-700">
        <div
          onClick={handleLogout}
          className={`flex items-center gap-3 cursor-pointer hover:text-primary ${
            isLoggingOut ? "opacity-50 pointer-events-none" : ""
          }`}
        >
          <i className="fas fa-sign-out-alt text-xl"></i>
          <span>{isLoggingOut ? "Logging out..." : "Logout"}</span>
        </div>
      </div>
    </div>
  );
};

export default Sidebar;
